module.exports = __webpack_public_path__ + "fonts/Rubik-Light.a742834a.ttf";